var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.000244141,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F5F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_845_17060)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9472 8.42139V9.73718M11.0525 8.42139V9.73718",
    stroke: "#141B34",
    strokeWidth: 1.18421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.997 15.6577H15.0029M14.997 18.2893H15.0029M17.6257 15.6577H17.6316M12.3684 15.6577H12.3743M12.3684 18.2893H12.3743",
    stroke: "#141B34",
    strokeWidth: 1.57895,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.40771 12.3687H20.5919",
    stroke: "#141B34",
    strokeWidth: 1.18421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74976 15.1602C8.74976 12.2935 8.74976 10.8602 9.57352 9.96966C10.3973 9.0791 11.7231 9.0791 14.3748 9.0791H15.6248C18.2764 9.0791 19.6022 9.0791 20.426 9.96966C21.2498 10.8602 21.2498 12.2935 21.2498 15.1602V15.498C21.2498 18.3647 21.2498 19.798 20.426 20.6885C19.6022 21.5791 18.2764 21.5791 15.6248 21.5791H14.3748C11.7231 21.5791 10.3973 21.5791 9.57352 20.6885C8.74976 19.798 8.74976 18.3647 8.74976 15.498V15.1602Z",
    stroke: "#141B34",
    strokeWidth: 1.18421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.07886 12.3687H20.921",
    stroke: "#141B34",
    strokeWidth: 1.18421,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_845_17060"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7895,
    height: 15.7895,
    fill: "white",
    transform: "translate(7.10498 7.10547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.3cd1ed0dee2c0574c5fc212485d51a63.svg";
export { ForwardRef as ReactComponent };